import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchUsageSuccess, fetchUsageFailure } from '../../actions/deployments/usage';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* fetchDeploymentUsageData(action) {
  try {
    const { deployment_id, period = '24h', bin_size = 'hour' } = action.payload;
    
    // Get headers using the same pattern as other sagas
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    
    // Build query parameters
    const params = new URLSearchParams();
    params.append('period', period);
    params.append('bin_size', bin_size);
    
    const response = yield call(
      axios.get,
      `${config.API_URL}/inference/deployments/${deployment_id}/usage?${params}`,
      { headers }
    );
    
    yield put(fetchUsageSuccess(response.data));
    
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchUsageFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchDeploymentUsageData);
}
